var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoCanvas(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-logo-canvas"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo-canvas",
    clipPath: "url(#clip-logo-canvas)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_17",
    "data-name": "Caminho 17",
    d: "M237.111,258.161a73.88,73.88,0,0,0-65-73.361,294.28,294.28,0,0,0,0,146.722A73.761,73.761,0,0,0,237.111,258.161Z",
    transform: "translate(-162.825 -2.724)",
    fill: "#e43d30"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_18",
    "data-name": "Caminho 18",
    d: "M244.528,216a23.247,23.247,0,1,0,23.167,23.328v-.161A23.07,23.07,0,0,0,244.528,216Z",
    transform: "translate(-127.286 16.27)",
    fill: "#e43d30"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_19",
    "data-name": "Caminho 19",
    d: "M434.9,258.161a73.88,73.88,0,0,0,65,73.361,294.279,294.279,0,0,0,0-146.722A74,74,0,0,0,434.9,258.161Z",
    transform: "translate(2.814 -2.724)",
    fill: "#e43d30"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_20",
    "data-name": "Caminho 20",
    d: "M416.989,216a23.248,23.248,0,1,0,23.006,23.488v-.322A23.243,23.243,0,0,0,416.989,216Z",
    transform: "translate(-22.391 16.27)",
    fill: "#e43d30"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_21",
    "data-name": "Caminho 21",
    d: "M349.361,343.7A73.88,73.88,0,0,0,276,408.7a294.279,294.279,0,0,0,146.722,0A73.88,73.88,0,0,0,349.361,343.7Z",
    transform: "translate(-93.924 94.014)",
    fill: "#e43d30"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22",
    "data-name": "Caminho 22",
    d: "M330.428,302.6a23.247,23.247,0,1,0,23.167,23.328v-.161A23.173,23.173,0,0,0,330.428,302.6Z",
    transform: "translate(-74.991 68.992)",
    fill: "#e43d30"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_23",
    "data-name": "Caminho 23",
    d: "M349.361,145.911a73.88,73.88,0,0,0,73.361-65,294.279,294.279,0,0,0-146.722,0A73.88,73.88,0,0,0,349.361,145.911Z",
    transform: "translate(-93.924 -71.625)",
    fill: "#e43d30"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_24",
    "data-name": "Caminho 24",
    d: "M330.367,130.1a23.167,23.167,0,1,0,23.167,23.167h0A23.173,23.173,0,0,0,330.367,130.1Z",
    transform: "translate(-74.93 -36.026)",
    fill: "#e43d30"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_25",
    "data-name": "Caminho 25",
    d: "M409.787,318.552a73.755,73.755,0,0,0-5.953,97.654A294.11,294.11,0,0,0,507.6,312.438,74.525,74.525,0,0,0,409.787,318.552Z",
    transform: "translate(-25.646 65.589)",
    fill: "#e43d30"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_26",
    "data-name": "Caminho 26",
    d: "M375.057,283.857a23.207,23.207,0,1,0,32.819,0h0A23.3,23.3,0,0,0,375.057,283.857Z",
    transform: "translate(-37.732 53.468)",
    fill: "#e43d30"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_27",
    "data-name": "Caminho 27",
    d: "M278.854,187.654A73.948,73.948,0,0,0,284.967,90,294.11,294.11,0,0,0,181.2,193.767,73.959,73.959,0,0,0,278.854,187.654Z",
    transform: "translate(-151.638 -60.438)",
    fill: "#e43d30"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_28",
    "data-name": "Caminho 28",
    d: "M253.157,161.957a23.207,23.207,0,1,0,32.819,0h0A23.3,23.3,0,0,0,253.157,161.957Z",
    transform: "translate(-111.945 -20.745)",
    fill: "#e43d30"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_29",
    "data-name": "Caminho 29",
    d: "M409.7,187.454a73.959,73.959,0,0,0,97.654,6.113A294.109,294.109,0,0,0,403.584,89.8,73.948,73.948,0,0,0,409.7,187.454Z",
    transform: "translate(-25.717 -60.56)",
    fill: "#e43d30"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_30",
    "data-name": "Caminho 30",
    d: "M407.8,194.7a23.207,23.207,0,1,0-32.819,0h0A23.3,23.3,0,0,0,407.8,194.7Z",
    transform: "translate(-37.816 -20.828)",
    fill: "#e43d30"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_31",
    "data-name": "Caminho 31",
    d: "M278.754,318.5a73.948,73.948,0,0,0-97.654-6.113A293.661,293.661,0,0,0,284.707,416.151,73.934,73.934,0,0,0,278.754,318.5Z",
    transform: "translate(-151.699 65.483)",
    fill: "#e43d30"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_32",
    "data-name": "Caminho 32",
    d: "M253.057,283.657a23.207,23.207,0,1,0,32.819,0h0A23.3,23.3,0,0,0,253.057,283.657Z",
    transform: "translate(-112.006 53.346)",
    fill: "#e43d30"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoCanvas);
export default __webpack_public_path__ + "static/media/logo-canvas.3e0f2fee.svg";
export { ForwardRef as ReactComponent };